<template>
    <div class="toast-container position-fixed top-0 end-0 p-3">
        <div id="saveToast" class="toast" role="alert" aria-live="assertive" aria-atomic="true">
            <div class="toast-header" :class="{'bg-success text-white': !error, 'bg-danger text-white': error}">
                <strong class="me-auto">{{ title }}</strong>
                <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
            </div>
            <div class="toast-body">
                {{ message }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ToastDialog',
    props: {
        title: {
            type: String,
            default: ''
        },
        message: {
            type: String,
            default: ''
        },
        error: {
            type: Boolean,
            default: false
        }
    }
}
</script>
